import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/profile/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    hasEditableHeader: true,
    pageTitle: 'Profile',
    tabKey: 'client/profile',
  },
  pendingComponent: Loading,
});
